<template>
  <summary-table
    data-field="income"
    format-type="number"
  />
</template>

<script>
import SummaryTable from '@core/components/summary/SummaryTable.vue'

export default {
  name: 'TotalProfit',
  components: {
    SummaryTable,
  },
}
</script>
